// extracted by mini-css-extract-plugin
export var divider = "_nn-0";
export var systemMessage = "_nn-1";
export var systemMessageWrapper = "_nn-2";